<template>
  <el-dialog :close-on-click-modal="false" :show-close="close" :center="center" :title="title" :visible.sync="dialogVisible" :top="top"
    :width="width" @close="handleClose" @open="handleOpen">
    <transition name="el-zoom-in-top">
      <div class="mb-[10] mx-[auto] " :style="alertStyle" v-show="tips.msg">
        <el-alert class="" @close="() => {
          tips.msg = '';
        }
          " v-show="tips.msg" :title="tips.msg" :type="tips.type" show-icon>
        </el-alert>
      </div>
    </transition>
    <div v-loading="showLoading">
      <slot></slot>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "dg-form-dialog",
  props: {
    title: String,
    width: String,
    top: String,
    visible: Boolean,
    center: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: true,
    },
    // 
    alertStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tips: {
        msg: "",
        type: "error",
      },
      showLoading: false,
      dialogVisible: false,
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
      },
      immediate: true,
    },
  },
  methods: {
    handleOpen() {
      this.tips.msg = ""
      Mirror.emit("dg_form_dialog_open");
    },
    handleClose() {
      Mirror.emit("dg_form_dialog_close");
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
  mounted() {
    let time = null;
    Mirror.watch("tips_dg_form_dialog_open", (key, msg) => {
      if (typeof msg == "string") {
        this.tips.msg = msg;
        this.tips.type = "error";
      } else {
        if (msg.type == "success") {
          clearInterval(time);
          setTimeout(() => {
            this.tips.msg = "";
          }, 3000);
        }

        this.tips.msg = msg.msg;
        this.tips.type = msg.type;
      }
    });
    Mirror.watch("tips_dg_form_dialog_close", () => {
      this.tips.msg = "";
    });

    Mirror.watch("loading_dg_form_dialog_open", () => {
      this.showLoading = true;
    });
    Mirror.watch("loading_dg_form_dialog_close", () => {
      this.showLoading = false;
    });
  },
};
</script>
<style scoped></style>
 <style>.mb-\[10\] {
    margin-bottom: 10px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}</style>